"use strict";
/**
 * On click, scrolls user to top of current page
 *
 * @param {String} id - The id of the element, set as a string
 */
function scrollToTop(id) {
    const element = document.querySelector(id); // select the element by it's id
    if (element) {
        element.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    }
}
scrollToTop("#buttonScrollToTop");
